
   
    let loop = setInterval(() => {
      if(document.querySelectorAll(".spb-label-tooltip").length) {
        clearInterval(loop);
        restyleRF();
      }
    }, 100)
    setTimeout(() => {
      clearInterval(loop);
    }, 15000)

function restyleRF() {
    setTimeout(() => {
  let a = document.querySelector('shop-pay-wallet-button')
  if (a) {
    a.style.display = 'block'
  }
    }, 1000)
}

window.addEventListener("cart_changed", t => setTimeout(() => {
    BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData)
}, 300))